<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  
  created () {
    console.log("%cEytuo.com%c\n  为你提供最好的服务\n", "font-size:66px;color:#3b3e43", "font-size:12px;color:rgba(0,0,0,0.38);");
    let result = this.IsPC()
    if ( !result ) {
      window.location.href = '../changzhou-museum-mobile/#/'
    }
  },

  methods: {
    IsPC() {
      var userAgentInfo = navigator.userAgent;
      var Agents = ["Android", "iPhone",
            "SymbianOS", "Windows Phone",
            "iPad", "iPod"];
      var flag = true;
      for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
          flag = false;
          break;
        }
      }
      return flag;
    }
  },
}
</script>

<style lang="stylus">
.overflow 
  overflow auto
  &::-webkit-scrollbar
    width 8px
  &::-webkit-scrollbar-track
    background #ccc
    border-radius 4px
  &::-webkit-scrollbar-thumb 
    border-radius 4px
    background #99be70
.italic
  font-style italic
</style>
